export interface KeyValuePair {
  id: string;
  key: string;
  value: string;
}

let nextId = 0;
export function newPairId(): string {
  return `kv-${++nextId}`;
}

export function entriesToPairs(entries: Record<string, string>): KeyValuePair[] {
  return Object.entries(entries).map(([key, value]) => ({ id: newPairId(), key, value }));
}

export function pairsToEntries(pairs: KeyValuePair[]): Record<string, string> {
  const out: Record<string, string> = {};
  for (const p of pairs) {
    if (p.key.trim()) out[p.key.trim()] = p.value;
  }
  return out;
}
